import { inject, Injectable } from '@angular/core';
import { User } from 'firebase/auth';
import { CurrentUserService } from '../../common/current-user/current-user.service';
import { FirebaseService } from '../../common/firebase/firebase.service';
import {
  BusinessAccountDto,
  BusinessRegistrationTypeEnum,
  UserAccessRolesEnum,
  UserResponseDto,
} from './auth.types';

export type {
  BusinessAccountDto,
  UserResponseDto,
  CreateUserDto,
} from './auth.types';
export {
  BusinessRegistrationTypeEnum,
  UserAccessRolesEnum,
} from './auth.types';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly currentUser = inject(CurrentUserService);
  private readonly firebaseService = inject(FirebaseService);

  appAvailable = true;
  registrationEmail: string | undefined;
  registrationPassword: string | undefined;
  loadingDashboard = false;

  get userRoles(): number[] {
    return this.currentUser.userRoles();
  }

  get isLoggedIn(): boolean {
    return !!this.firebaseService.accessToken;
  }

  get isEmailVerified(): boolean {
    return !!this.firebaseService.userId;
  }
}

export type { BusinessAccountDto as BusinessAccountDtoType };
